import type React from 'react';

export interface InvoiceIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	'aria-label'?: string;
}

const InvoiceIcon: React.FC<InvoiceIconProps> = ({
	width = 23,
	height = 29,
	fill = 'white',
	'aria-label': ariaLabel = 'Invoice',
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 23 29"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label={ariaLabel}
		>
			<title>Invoice Icon</title>
			<path
				d="M11.3373 0L11.5031 0.00992008C11.8194 0.0472252 12.114 0.190012 12.3392 0.415244C12.5644 0.640476 12.7072 0.935019 12.7445 1.25135L12.7544 1.41716V7.0858L12.7615 7.29838C12.8122 7.97319 13.1027 8.60759 13.5805 9.08688C14.0582 9.56617 14.6916 9.85871 15.3663 9.91162L15.5888 9.92013H21.2574L21.4232 9.93005C21.7396 9.96735 22.0341 10.1101 22.2593 10.3354C22.4846 10.5606 22.6273 10.8551 22.6647 11.1715L22.6746 11.3373V24.0917C22.6746 25.1762 22.2603 26.2196 21.5163 27.0086C20.7724 27.7976 19.7551 28.2725 18.6725 28.3361L18.4231 28.3432H4.25148C3.16706 28.3433 2.12359 27.9289 1.3346 27.185C0.545597 26.441 0.0707057 25.4237 0.00708597 24.3412L6.6046e-09 24.0917V4.25148C-6.04018e-05 3.16706 0.414272 2.12359 1.15822 1.3346C1.90217 0.545597 2.9195 0.0707057 4.00206 0.00708597L4.25148 0H11.3373ZM17.0059 21.2574H14.1716C13.7958 21.2574 13.4353 21.4067 13.1695 21.6725C12.9038 21.9383 12.7544 22.2987 12.7544 22.6746C12.7544 23.0504 12.9038 23.4109 13.1695 23.6767C13.4353 23.9424 13.7958 24.0917 14.1716 24.0917H17.0059C17.3818 24.0917 17.7422 23.9424 18.008 23.6767C18.2738 23.4109 18.4231 23.0504 18.4231 22.6746C18.4231 22.2987 18.2738 21.9383 18.008 21.6725C17.7422 21.4067 17.3818 21.2574 17.0059 21.2574ZM17.0059 15.5888H5.66864C5.29279 15.5888 4.93233 15.7381 4.66656 16.0038C4.40079 16.2696 4.25148 16.6301 4.25148 17.0059C4.25148 17.3818 4.40079 17.7422 4.66656 18.008C4.93233 18.2738 5.29279 18.4231 5.66864 18.4231H17.0059C17.3818 18.4231 17.7422 18.2738 18.008 18.008C18.2738 17.7422 18.4231 17.3818 18.4231 17.0059C18.4231 16.6301 18.2738 16.2696 18.008 16.0038C17.7422 15.7381 17.3818 15.5888 17.0059 15.5888ZM7.0858 5.66864H5.66864C5.29279 5.66864 4.93233 5.81795 4.66656 6.08372C4.40079 6.34949 4.25148 6.70995 4.25148 7.0858C4.25148 7.46166 4.40079 7.82212 4.66656 8.08789C4.93233 8.35366 5.29279 8.50296 5.66864 8.50296H7.0858C7.46166 8.50296 7.82212 8.35366 8.08789 8.08789C8.35366 7.82212 8.50296 7.46166 8.50296 7.0858C8.50296 6.70995 8.35366 6.34949 8.08789 6.08372C7.82212 5.81795 7.46166 5.66864 7.0858 5.66864Z"
				fill={fill}
			/>
			<path d="M21.2575 7.08583H15.5888L15.5874 1.41577L21.2575 7.08583Z" fill={fill} />
		</svg>
	);
};

export default InvoiceIcon;

